import React, { Component } from "react";
import * as Sentry from "@sentry/react";

import { MessagePageLayout } from "../../../index";

import errorImage from "../../../../../../assets/images/mercurio_error_505.svg";

export class ErrorBoundaryClass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      errorInfo: null,
    };

    if (this.props.loggedUser) {
      Sentry.setUser({ id: this.props.loggedUser.id });
    }
  }

  componentDidCatch(error, errorInfo) {
    //? catch errors in any component and report it to Sentry.
    this.setState(
      {
        error: error,
        errorInfo: errorInfo,
      },
      () => {
        Sentry.captureException(error, {
          extra: errorInfo,
        });
      }
    );
  }

  render() {
    if (this.state.error) {
      return (
        <MessagePageLayout
          imageProps={{ src: errorImage }}
          text="Parece que algo salió mal de nuestro lado y te pedimos perdón. Pronto lo estaremos solucionando."
          subText={this.state.error.message}
          title="¡Ups! Algo salió mal..."
        />
      );
    }

    return this.props.children;
  }
}
